import { placeOfPersonConnectionService } from "../../../services/connections/placeOfPersonService";
import {
  SystemEntityCollections,
} from "../../../shared/enums/shared-enums";
import {
  PlaceOfPerson,
  PlaceOfPersonFilters,
} from "../../../types/placeOfPerson";
import usePlaceOfPersonLogic from "../../logic/connections/placeOfPersonLogic";
import useConnectionQueryClient from "./connectionQueryClient";

const usePlaceOfPersonQuery = () => {
  const { defaultPlaceOfPerson, getDisplayName } = usePlaceOfPersonLogic(
    null,
    null
  );
  return useConnectionQueryClient<PlaceOfPerson, PlaceOfPersonFilters>({
    service: placeOfPersonConnectionService,
    collection: SystemEntityCollections.PLACE_OF_PERSON,
    defaultConnection: defaultPlaceOfPerson,
    snackbarDisplayName: getDisplayName,
  });
};

export default usePlaceOfPersonQuery;
